import firebase from 'firebase/app'
import 'firebase/messaging'

import commonsApi from '@/api/commons'
import messaging from '@/helpers/firebaseMessaging'
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

const state = {
  token: '',
  initialized: false,
  onMessageNotification: {},
  notifications: [],
  unreadNotifications: 0,
  browserSupportFirebaseMessagin: ''
}

const getters = {
  unreadNotifications (state) {
    return state.unreadNotifications
  },
  token (state) {
    return state.token
  }
}

const actions = {
  checkBrowserSupportFirebaseMessagin ({ commit }) {
    const support = firebase.messaging.isSupported()
    commit('mutateSetBrowserSupportFirebaseMessagin', support)
  },
  async actionClearUnreadNotifications ({ commit, state }) {
    if (state.unreadNotifications) {
      await commonsApi.updateItemDetail(process.env.VUE_APP_LUMBRE_NOTIFICATIONS_PATH)
    }
    commit('mutateClearUnreadNotifications')
  },
  async getNotifications ({ commit }) {
    const notifications = await commonsApi.getItems({
      path: process.env.VUE_APP_LUMBRE_NOTIFICATIONS_PATH,
      format: 'minimal'
    })

    if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_NOTIFICATIONS === 'yes') {
      notifications.data.items.forEach(i => (i.timeAgoDate = moment(i.date).fromNow()))
    }

    commit('mutateClearNotifications')
    commit('mutateNotifications', notifications.data.items)
    let estadoContentSinLeer
    if (!process.env?.VUE_APP_ENABLE_MICROSERVICES_NOTIFICATIONS === 'yes') {
      estadoContentSinLeer = notifications?.data?.aggregates?.Estado?.content.find(e => e.label === 'Sin Leer')
    } else {
      estadoContentSinLeer = notifications.data.items.filter(i => i.status === 'Sin Leer')
      estadoContentSinLeer.count = estadoContentSinLeer.length
    }
    if (estadoContentSinLeer && estadoContentSinLeer.count) {
      commit('mutateUnreadNotifications', estadoContentSinLeer.count)
    }
  },
  requestPermission ({
    dispatch
  }) {
    // Ask user form permission
    messaging.requestPermission().then(() => {
      // Get Token
      messaging.getToken().then((token) => {
        dispatch('persistToken', token)
      })
    }).catch((err) => {
      console.log('Unable to get permission to notify.', err)
    })
  },
  async initializeNotifications ({
    commit,
    dispatch,
    state,
    rootState
  }) {
    if (
      process.env.VUE_APP_ENABLE_FCM_NOTIFICATIONS === 'yes' &&
    !state.initialized &&
    rootState.session.isAuthenticated &&
    state.browserSupportFirebaseMessagin) {
      // Initialize Firebase
      commit('mutateSetInitialized')
      if ('Notification' in window) {
        // El browser soporta notificaciones
        // eslint-disable-next-line
        if (Notification.permission === 'granted') {
          messaging.getToken().then((token) => {
            dispatch('persistToken', token)
          })
        }

        // Notificaciones en primer plano
        messaging.onMessage((payload) => {
          // Solo los usuarios autenticados reciben push
          if (rootState.session.isAuthenticated) {
            commit('mutateOnMessageNotification', payload)
          }
        })

        // Callback fired if Instance ID token is updated.
        messaging.onTokenRefresh(() => {
          // XXX: Se deberia invalidar el token previo
          // Y luego obtener el nuevo token y persistirlo
          messaging.getToken().then((refreshedToken) => {
            dispatch('persistToken', refreshedToken)
          }).catch((err) => {
            console.log('Unable to refresh token', err)
          })
        })
      }
    } else if (process.env.VUE_APP_ENABLE_FCM_NOTIFICATIONS === 'yes' &&
    state.initialized &&
    rootState.session.isAuthenticated) {
      console.log('intentando obtener el token nuevamente')
      messaging.getToken().then((token) => {
        dispatch('persistToken', token)
      })
    }
  },
  async persistToken ({ commit, rootState }, token) {
    if (rootState.session.isAuthenticated && token) {
      const newTokenEndpoint = process.env?.VUE_APP_NOTIFICATION_NEW_TOKEN_ENDPOINT || 'notificaciones/token/nuevo/'
      await commonsApi.updateItemDetail(newTokenEndpoint, {
        token
      })
      commit('mutateSetToken', token)
    }
  }
}

const mutations = {
  mutateUpdateTimeAgo (state) {
    state.notifications.forEach(n => (n.timeAgoDate = moment(n.date).fromNow()))
  },
  mutateSetBrowserSupportFirebaseMessagin (state, payload) {
    state.browserSupportFirebaseMessagin = payload
  },
  mutateSetInitialized (state) {
    state.initialized = true
  },
  mutateClearInitialized (state) {
    state.initialized = false
  },
  mutateOnMessageNotification (state, payload) {
    state.onMessageNotification = payload.notification
  },
  mutateNotifications (state, payload) {
    const notifications = payload.map(notification => {
      if (!notification?.icon) {
        notification.icon = localStorage.getItem('favicon')
      }
      return notification
    })
    state.notifications.push(...notifications)
  },
  mutateUnreadNotifications (state, payload) {
    state.unreadNotifications = payload
  },
  mutateClearUnreadNotifications (state) {
    state.unreadNotifications = 0
  },
  mutateClearNotifications (state) {
    state.notifications.length = 0
  },
  mutateSetToken (state, payload) {
    state.token = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
